import AboutCard from "../components/allProgrammes/aboutCard"
import Heading from "../components/heading"
import { PropTypes } from 'prop-types';

const ExploreProgrammes = ({descriptionHeading,description}) => {
    return (
        <div className="w-full  bg-[#161624] text-white grid grid-cols-1 px-4 xl:px-[12rem] py-12 md:grid-cols-2 gap-16">
            <div className="flex flex-col gap-3">
                <Heading name="Explore Programmes" color="text-white" />
                <h1 className="self-stretch w-auto xl:max-w-[18ch]  text-5xl font-bold leading-tight ">
                    {descriptionHeading}
                </h1>
                <p className="w-auto   2xl:max-w-7xl text-justify   text-opacity-70 text-base font-normal  leading-normal">{description}</p>
            </div>
            <div className="relative w-full ">
                <div className="md:absolute md:-bottom-[35%] md:z-20 w-full flex items-center justify-center">
                    <AboutCard/>
                </div>
            </div>
        </div>
    )
}
ExploreProgrammes.propTypes = {
    description:PropTypes.string,
    descriptionHeading:PropTypes.string
}
export default ExploreProgrammes